<template>
  <b-container>
    <h4 class="my-4">Impersonate</h4>
    <div style="min-height: 400px">
      <b-table
          ref="table"
          striped
          :items="fetchList"
          :current-page="pagination.page"
          :fields="fields"
          :busy.sync="loading"
          :table-class="'user-list'"
          outlined
          head-variant="light"
          :show-empty="true"
          :sort-by="sorting.column"
          :sort-desc="sorting.asc"
      >
        <template #empty="scope">
       <div class="text-center m-5">No results</div>
    </template>

        <template #top-row="header">
          <td v-for="field in header.fields" :key="field.key">
            <b-input v-model="filters[field.key]" :placeholder="field.label" v-if="field.filterable"
                     @change="updateFilter"/>
          </td>
        </template>
        <template #cell(actions)="row">
          <b-button variant="success" size="sm" @click="onImpersonate(row.item)">Impersonate</b-button>
        </template>
      </b-table>
    </div>
    <b-pagination
        v-model="pagination.page"
        :total-rows="pagination.total"
        :per-page="pagination.page_size"
        aria-controls="my-table"
        :class="'user-pagination'"
    ></b-pagination>
  </b-container>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'Users',

  data() {
    return {
      loading: false,
      fields: [
        {key: 'id', label: 'ID'},
        {key: 'first_name', label: 'First name', sortable: true, filterable: true},
        {key: 'last_name', label: 'Last name', sortable: true, filterable: true},
        {key: 'email', label: 'Email', sortable: true, filterable: true},
        {key: 'actions', label: ''},
      ],
      filters: {
        first_name: '',
        last_name: '',
        email: '',
      },
      pagination: {
        page: 1,
        page_size: 20,
        total: 0
      },
      sorting: {
        column: 'email',
        asc: true
      }
    }
  },
  methods: {
    ...mapActions('impersonate', [
      'fetchUsersList',
      'impersonate'
    ]),
    updateFilter() {
      this.$refs.table.refresh()
    },
    async fetchList(ctx) {
      this.loading = true
      const params = {
        filters: this.filters,
        pagination: {
          page_size: 20,
          page: ctx.currentPage,
        },
        sorting: {
          column: ctx.sortBy,
          asc: ctx.sortDesc
        }
      }
      const users = await this.fetchUsersList(params)
      this.loading = false
      this.pagination.total = users.pagination.total
      this.pagination.page_size = users.pagination.page_size
      this.pagination.page = users.pagination.page
      return users.results
    },
    async onImpersonate(user) {
      await this.impersonate(user)
      await this.$router.push({name: 'checkins-list'})
    }
  }
}
</script>

